import { render, staticRenderFns } from "./PastEmployment.vue?vue&type=template&id=085380f2&scoped=true&"
import script from "./PastEmployment.vue?vue&type=script&lang=js&"
export * from "./PastEmployment.vue?vue&type=script&lang=js&"
import style0 from "./PastEmployment.vue?vue&type=style&index=0&id=085380f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085380f2",
  null
  
)

component.options.__file = "PastEmployment.vue"
export default component.exports